import type { Log, LogFilter } from '@/features/log/types/Log';
import type { Filter } from '@/std/hooks/useFilter';
import { LogsDetalhesModal } from '@/features/log/components/LogsDetalhesModal';
import { LogsTable } from '@/features/log/components/LogsTable';
import { useDialog } from '@/std/dialog/useDialog';

export function LogsTab({ filter, enabled }: { filter: Filter<LogFilter>; enabled?: boolean }) {
    const dialog = useDialog<Log>();

    return (
        <div className='w-full px-2 py-0'>
            <LogsTable enabled={enabled} filter={filter} open={(row) => dialog.actions.open(row)} />
            <LogsDetalhesModal dialog={dialog} />
        </div>
    );
}
